import { stubbedCustomRouteMap } from './stubbedCustomRouteMap';

export const stubbedCustomRouteMapResponse = {
  maps: [
    {
      ...stubbedCustomRouteMap,
      name: null,
      description: null,
      estimatedTimeToComplete: null
    }
  ],
  meta: {
    status: 'ok',
    items: 1,
    timestamp: '2025-03-06T01:46:35Z'
  },
  pageInfo: null
};
